import { MAX_CHARACTER_EMAIL_VALIDATION, MAX_CHARACTER_INPUT_VALIDATION, MAX_CHARACTER_ORGANIZATION_ID_VALIDATION } from "@/constants/common";
import { INVALID_PASSWORD_CONFIRM } from "@/constants/invalids";
import { validator } from "@/utils/validator";

export const registerSchema = validator.object().shape({
  ownerId: validator
    .string()
    .trim()
    .emptyToNull()
    .autoTransformToHalfWidthForMatchLicenseNumber()
    .max(MAX_CHARACTER_ORGANIZATION_ID_VALIDATION)
    .label("組織ID")
    .required(),
  email: validator.string().trim().emptyToNull().max(MAX_CHARACTER_EMAIL_VALIDATION).label("メールアドレス").required(),
  newPassword: validator.string().trim().emptyToNull().strongPassword().max(MAX_CHARACTER_INPUT_VALIDATION).label("パスワード").required(),
  confirmNewPassword: validator
    .string()
    .trim()
    .max(MAX_CHARACTER_INPUT_VALIDATION)
    .when("newPassword", {
      is: (newPassword: string) => newPassword && newPassword.length > 0,
      then: (schema) => schema.oneOf([validator.ref("newPassword")], INVALID_PASSWORD_CONFIRM),
      otherwise: (schema) => schema.required(),
    })
    .label("パスワード（確認用）"),
});
